import { FacturacionCPEService } from 'app/services/facturacion-cpe/facturacion-cpe.service';
import { Component,OnInit, EventEmitter, ViewChild, Output, Input } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import Swal from "sweetalert2";
import { ComprobantePago } from "./../../../models/ComprobantePago";
import { EmpresasService } from 'app/services/empresas/empresas.service';
@Component({
  selector: 'app-detalle-listado',
  templateUrl: './detalle-listado.component.html',
  styleUrls: ['./detalle-listado.component.scss']
})

export class DetalleListadoComponent implements OnInit {

  @Output() cerrarDetalle = new EventEmitter<boolean>();
  @Input() idComprobanteIF:number = 0;


  loading: boolean;
  facturas: any = [];
  dataSource: any;
  dataSource1 = new MatTableDataSource();
  tipoDocumentoElement: any;
  dataFactura: any;

  serie:any;
  numero:any;
  cliente:any;
  fecha: any
  error : boolean = false;
  textError: string = "";
  Contacto : string = "Cargando..";
  contactos:any;
  correoEnviar:String;
  documento:any = new ComprobantePago();
  documentoDetalle: any = [];
  Comentario : String ="Cargando..";
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['Nro_Item','Codigo_Producto', 'Cantidad', 'Unidad_Medida', 'Descripcion', 'Valor_Unitario', 'IGV_Importe', 'Precio_Venta'];

  constructor(private cpeService: FacturacionCPEService,private empresasService:EmpresasService){}

  ngOnInit() { 
    this.obtenerDocumento(this.idComprobanteIF);      
  }



  CerrarPopUp() {
    this.cerrarDetalle.emit();
  }

  obtenerDocumento(id) {
    this.loading = true;
    this.cpeService.ObtenerDocumentoPorId(id).subscribe(
      res => { 
        this.loading = true;
        this.documento = res['data'];
        this.ListarContacto(this.documento.idEmpresa);  
        this.Contacto = this.documento.Correo;
        this.documentoDetalle = this.documento.detail;
        console.log(this.documento.Precio_Venta);
        if(this.documento.Precio_Venta != 0.00){
          this.Comentario = "OP.GRAVADAS"
        }else{
          this.Comentario = "INAFECTA"
        }
        this.dataSource = new MatTableDataSource(this.documentoDetalle);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
              
        this.loading = false;
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    )
  }

  ListarContacto(idEmpresa){
    this.loading = true;    
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {       
          this.contactos = res;
          this.contactos = this.contactos.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 
          );
          this.loading = false;
      },err =>{
        this.textError = err.error['error'];
        this.error = true;
        this.loading = false;
      }
    );
  }

  guardarContacto(idComprobanteIF,Correo){
    Swal.fire({
      title: 'Espere',
      text: 'Actualizando informacion.',
      type: 'info',
      heightAuto: false
    });
    Swal.showLoading();  
    let dataenviar = {
      "idComprobanteIF":idComprobanteIF,
      "correo":Correo
    }
    this.cpeService.UpdateCP(dataenviar).subscribe(
      res => {    
        if(this.loading == false){
          Swal.fire({
            title: 'Terminado',
            text: 'Se guardo con éxito',
            type: 'success',
            heightAuto: false
          }); 
        }        
          this.obtenerDocumento(this.idComprobanteIF);  
      },err =>{        
        this.textError = err.error['error'];
        this.error = true;
        Swal.fire({
          title: 'Error',
          text: this.textError,
          type: 'error',
          heightAuto: false
        });
      }
    );
  }
}